// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1ge76","content":"LayoutSettings_content__6VbOF"};